import React from 'react';
import { AppSidebarToggler } from '_components';

const DefaultHeader = () => (
  <div className='app-header'>
    <AppSidebarToggler className='d-lg-none' display='md' mobile />
    <a className='navbar-brand' href='/'>
      <img src='img/CR_Epiroc_White_150.png' alt='CR Digital' />
    </a>
  </div>
);

export default DefaultHeader;
